import { LensConfig, LensProvider, production } from "@lens-protocol/react-web";
import {
  RainbowKitProvider,
  darkTheme,
  RainbowKitAuthenticationProvider,
} from "@rainbow-me/rainbowkit";
import { WagmiProvider } from "wagmi";

import { bindings } from "./bindings";
import { siweAdapter } from "./siweAdapter";
import { wagmiConfig } from "./wagmiConfig";

const lensConfig: LensConfig = {
  environment: production,
  bindings: bindings(wagmiConfig),
  debug: true,
};

export function Web3Provider({ children }: { children: React.ReactNode }) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <RainbowKitAuthenticationProvider
        status="unauthenticated"
        adapter={siweAdapter}
      >
        <RainbowKitProvider theme={darkTheme()}>
          <LensProvider config={lensConfig}>{children}</LensProvider>
        </RainbowKitProvider>
      </RainbowKitAuthenticationProvider>
    </WagmiProvider>
  );
}
